import styled from "styled-components";

export const FooterSection = styled.footer`
  background-color: var(--paper);
  padding: 4rem 0 2rem;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FooterColumn = styled.div`
  flex: 1;
  min-width: 200px;

  h4 {
    color: var(--text-primary);
    margin-bottom: 1.25rem;
    font-size: 1rem;
    font-weight: 650;
  }

  a {
    color: var(--text-secondary);
    display: block;
    margin-bottom: 0.75rem;
    transition: color 0.3s ease;

    &:hover {
      color: var(--accent-primary);
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;

  a {
    color: var(--text-secondary);
    font-size: 1.5rem;
    transition: color 0.3s ease, transform 0.3s ease;

    svg, img {
      stroke: currentColor;
      fill: none;
      color: var(--text-secondary);
      transition: all 0.3s ease;
    }

    &:hover {
      color: var(--accent-primary);
      transform: scale(1.1);

      svg, img {
        stroke: var(--accent-primary);
        color: var(--accent-primary);
      }
    }
  }
`;

export const Brand = styled.div`
  flex: 1.4;
  min-width: 240px;

  img {
    display: block;
    margin-bottom: 1.25rem;
  }
  p {
    max-width: 22rem;
    margin: 0;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: var(--text);
  }
`;

export const Copyright = styled.p`
  margin-top: 3.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--line);
  color: var(--text-secondary);
  font-size: 0.9rem;
`;
